import { BrowserRouter } from 'react-router-dom';
import PWAPrompt from 'react-ios-pwa-prompt'
import { createTheme, ThemeProvider } from '@mui/material';

import './App.css';
import Navigation from './navigation';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
});


function App() {
  return <BrowserRouter basename={process.env.PUBLIC_URL}>
    <ThemeProvider theme={theme}>
      <Navigation />
    </ThemeProvider>
    <PWAPrompt copyTitle="Download Tecnea Hydrotest" />
  </BrowserRouter>
}

export default App;
